module.exports = __webpack_public_path__ + "static/media/icons_Bilan Genou.c76acef6.svg";